<template>
  <div class="booking-overview" :class="{'booking-overview--hide': step < 6}" v-if="selectedVehicle">
    <img class="booking-overview__vehicle" :class="{'overview-box__not-found-image': this.carNotFound}" :src="vehicleImage" alt="Car Image" />

    <div class="booking-overview__blue-box">
      <h3 class="booking-overview__card-heading">{{ vehicleDetails.make + " " + vehicleDetails.model }}</h3>
      <p class="booking-overview__card-text" v-show="!this.carNotFound">{{ vehicleDetails.derivative }}</p>
    </div>

    <div class="booking-overview__box-container" v-if="step > 4 && step < 8">
      <div class="booking-overview__blue-box">
        <h3 class="booking-overview__card-heading summary__card-heading--mb">Service details</h3>
        <div v-if="haveManufactureUpdate" class="booking-overview__blue-box-row">
          <p class="booking-overview__card-text">Manufacturer Updates</p>
          <p class="booking-overview__card-text booking-overview__price">Free</p>
        </div>
        <div v-for="(option, index) in selectedOptionsArray" class="booking-overview__blue-box-row" :key="index">
          <p class="booking-overview__card-text">{{ option.display_name }}</p>

          <p class="booking-overview__card-text booking-overview__price" v-if="!haveServicePlan && option.price > 0">{{ option.display_price }}</p>
        </div>
      </div>

      <div class="booking-overview__blue-box booking-overview__total-cost-box" v-if="!haveServicePlan && !fallbackPricing && subTotal > 0">
        <p class="booking-overview__total-cost">Your personalised service cost</p>
        <p class="booking-overview__price booking-overview__card-text">£{{ parseFloat(subTotal).toFixed(2) }}</p>
      </div>

    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';

export default {
  computed: {
    ...mapState('OSB', ['step', 'selectedVehicle', 'nonFranchiseVehicle', 'otherSelected', 'carNotFound', 'pricingData', 'selectedOptions', 'fallbackPricing', 'haveServicePlan', 'manufacturerUpdate']),
    ...mapGetters('OSB', ['vehicleImage', 'selectedOptionsArray', 'subTotal']),

    vehicleDetails() {
      if(this.otherSelected) {
        return this.nonFranchiseVehicle;
      }

      return this.selectedVehicle;
    },

    serviceLevel() {
      let serviceLevelName = this.pricingData.service_pricing.name;

      if(this.pricingData.service_pricing.age < 3) {
        return serviceLevelName.toLowerCase();
      }

      return serviceLevelName.slice(0, serviceLevelName.indexOf(' ')).toLowerCase();
      // return serviceLevelName.toLowerCase();
    },

    haveManufactureUpdate() {
      if (this.manufacturerUpdate?.['needsCheck'] == true) {
        return true;
      }
      return false;
    },

  },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/online-service-booking/components/BookingOverview.vue